import styled from "styled-components";

const IndicatorBall = styled.span<{ color?: string; small?: boolean }>`
    width: ${({ small }) => (small ? "0.8rem" : "1.2rem")};
    height: ${({ small }) => (small ? "0.8rem" : "1.2rem")};
    border-radius: 100%;
    display: inline-block;
    background: ${({ color }) => color ? color : "#FE8418"};
    box-shadow: 0px 0px ${({ small }) => (small ? "4px" : "8px")} rgba(0, 0, 0, 0.25);
`;

export default IndicatorBall;
